var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',_vm._b({attrs:{"max-width":"250","src":_vm.baseUrl + 'logo-original-white.png',"contain":""}},'v-img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }